module.exports = __webpack_public_path__ + "img/menu-icon-attachment.ceae0c18.svg";